import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import CountryList from './CountryList'
import CountryAdd from './CountryAdd'
import CountryEdit from './CountryEdit'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import helpers from '../../utils/helpers'
import OSearch from 'components/reusable/OSearch'

const CountryManager = () => {
  const { user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'country_manager') ?? {}
  const { t } = useTranslation()

  const [countryList, setCountryList] = useState([])
  const [countryAdd, setCountryAdd] = useState(false)
  const [countryEdit, setCountryEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [countryView, setCountryView] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    category: '',
    searchKey: '',
    isFilter: false,
    isReset: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setCountryEdit(!countryEdit)
  }

  const handleView = item => {
    setCurrentItem(item)
    setCountryView(!countryView)
  }

  const handleCategory = () => {
    setCountryAdd(!countryAdd)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allCountry = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && countryList?.length >= 1) ||
        (isFilter && category && data?.statusChange && countryList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.countryList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setCountryList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all country list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allCountry()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      startDate: '',
      endDate: '',
      category: '',
      searchKey: '',
      isFilter: false,
      isReset: true
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    updatePageName(t('COUNTRY_MANAGER'))
  }, [])

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <div className='relative flex items-center mb-3'>
                    <OSearch
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      placeholder={t('SEARCH_BY_COUNTRY')}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />

                  <OButton
                    label='Reset'
                    type='button'
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
              <div className='flex items-center justify-end px-4 ms-auto mb-3'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    title='Add country'
                    type='button'
                    className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    onClick={() => handleCategory()}
                  >
                    + {t('ADD_COUNTRY')}
                  </button>
                )}
              </div>
            </form>
            <CountryList
              countryList={countryList}
              allCountry={allCountry}
              page={page}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              countryView={countryView}
              setSort={setSort}
              sort={sort}
              manager={manager}
            />

            {countryEdit && (
              <CountryEdit
                handleEdit={handleEdit}
                currentItem={currentItem}
                allCountry={allCountry}
              />
            )}

            {countryAdd && (
              <CountryAdd
                allCountry={allCountry}
                countryAdd={countryAdd}
                handleCategory={handleCategory}
                setPage={setPage}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default CountryManager
